import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { Button } from 'components/Button'
import { StyledModal as S } from 'components/Modal/Modal.styles'

import { selectAppName, selectError } from 'root-redux/selects/common'

import { selectIsModalShown } from 'modules/contactForm/redux'

import { AppName, READABLE_APP_NAMES } from 'root-constants'

import { StyledWithdrawModal as SW } from './WithdrawModal.styles'

type TProps = {
  name: string
  surname: string
  email: string
  onClose: () => void
  userId?: string
}

export const WithdrawModal: React.FC<TProps> = ({
  name,
  surname,
  email,
  onClose,
  userId,
}) => {
  const { t } = useTranslation()
  const isShown = useSelector(selectIsModalShown)
  const error = useSelector(selectError)
  const appName = useSelector(selectAppName)
  const readableAppName = READABLE_APP_NAMES[appName as AppName] || appName

  const now = new Date()
  const date = now.toLocaleDateString('en-GB')
  const time = now.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
  })

  return (
    <S.Wrapper isShown={isShown}>
      <S.Content>
        {error ? (
          <S.Title>{error}</S.Title>
        ) : (
          <>
            <SW.Title>Your withdrawal request has been received</SW.Title>

            <SW.InfoBlock>
              <SW.InfoRow>
                <SW.Label>Name:</SW.Label> {name}
              </SW.InfoRow>
              <SW.InfoRow>
                <SW.Label>Surname:</SW.Label> {surname}
              </SW.InfoRow>
              <SW.InfoRow>
                <SW.Label>Email:</SW.Label> {email}
              </SW.InfoRow>
              {userId && (
                <SW.InfoRow>
                  <SW.Label>User ID:</SW.Label> {userId}
                </SW.InfoRow>
              )}
              <SW.InfoRow>
                <SW.Label>Submitted:</SW.Label> {date}, {time}
              </SW.InfoRow>
            </SW.InfoBlock>

            <SW.Text>
              Your subscription will be cancelled and a refund will be issued to
              your original payment method. Our support team will process your
              request within 30 days.
            </SW.Text>

            <SW.Text>
              You can still access all of {readableAppName} features until your
              current subscription ends.
            </SW.Text>
          </>
        )}

        <Button type="button" onClick={onClose}>
          {t('login.gotIt')}
        </Button>
      </S.Content>
    </S.Wrapper>
  )
}
